import { IonCol, IonGrid, IonRow, isPlatform } from "@ionic/react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import React, {
  ChangeEvent,
  forwardRef,
  ReactNode,
  SetStateAction,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { GenerateGUID } from "../../Common";

import api from "./../../../services/api";

// import { v4 as uuidv4, v4 } from "uuid";

type Props = {
  setContractType: React.Dispatch<React.SetStateAction<string>>;
  setContractTypeData: React.Dispatch<React.SetStateAction<ContractType | undefined>>;
  width?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  date?: string;
  driver?: string;
};

type Option = {
  id: string;
  data: ContractType;
  value: string;
}

export type ContractTypeContract = {
  id: number;
  name: string;
  baseSalary: number;
  bonusSalary: number;
  amountPerPoint: number;
  attendanceBonus: number;
  ecologicIndexBonus: number;
  fuelConsumptionBonus: number;
  isSalariesThresholdsAvailable: boolean;
}

export type ContractTypeThreshold = {
  id: number;
  daysRangeFrom: number;
  daysRangeTo: number;
  baseSalary: number;
  bonusSalary: number;
  amountPerPoint: number;
  attendanceBonus: number;
  ecologicIndexBonus: number;
  fuelConsumptionBonus: number;
}

export type ContractType = {
  contract: ContractTypeContract;
  thresholds: ContractTypeThreshold[];
}

const ContractTypeAutocomplete: React.FC<Props> = ({
  setContractType,
  setContractTypeData,
  width,
  date,
  driver,
  disabled = false,
  fullWidth = false,
}) => {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<readonly Option[]>([]);
  const loading = open && options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    api.get("autocomplete/driver-contract-types").then((response) => {
      setOptions(response.data);
    });

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <Autocomplete
      disabled={disabled}
      noOptionsText="Nie znaleziono"
      // id={v4()}
      sx={{
        width: {
          xs: "100%",
          sm: "100%",
          md: "100%"
        },
      }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => option === value}
      getOptionLabel={(option) => {
        return option.value;
      }}
      onChange={(event, value) => {
        setContractType(value?.value ?? "");
        setContractTypeData(value?.data)
      }}
      options={options}
      loading={loading}
      renderInput={(params) => (
        <TextField
          variant="filled"
          type={"search"}
          className="shadow-mui"
          {...params}
          id={GenerateGUID()}
          autoComplete={GenerateGUID()}
          label="Typ zatrudnienia"
          fullWidth={true}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default ContractTypeAutocomplete;
